import type { NoParams, Resolver } from '../../definition/resolver';
import type { RejectUndefinedData } from '../../../resources/types';
import { attachPromise } from './attachPromise';

export const fromPromise = <TData, TParams = NoParams>(
  name: string,
  fetch: (params: TParams) => Promise<TData>
): RejectUndefinedData<TData, Resolver<TParams, TData>> =>
  ({
    name,
    tags: ['promise'],
    attach: (params, runtime) =>
      attachPromise(fetch, params, runtime, 'promise'),
  }) as RejectUndefinedData<TData, Resolver<TParams, TData>>;
